import type { ApiQuestion } from '../../../../internalTypes';
import type { QuestionMedia } from '../../../../types/shared';

export function buildMediaConfig(question: ApiQuestion): QuestionMedia {
  const add = question.additional ?? {};

  let url = (add['mediaUrl'] as string | undefined) ?? (add['previewUrl'] as string | undefined);
  let mimeType = add['mediaMimeType'] as string | undefined;
  const title = add['title'] as string | undefined;

  const assets = question.questionContainerAssets;
  if (Array.isArray(assets) && assets.length > 0) {
    const asset = assets[0];
    if (asset.source || asset.previewImageUrl) {
      url = asset.source || asset.previewImageUrl;
    }
    if (asset.type) {
      if (asset.type === 'PHOTO' || asset.type === 'IMAGE') mimeType = 'image/*';
      else if (asset.type === 'VIDEO') mimeType = 'video/*';
      else mimeType = asset.type;
    }
  }

  const configs = question.questionConfigs || [];
  const alignConfig = configs.find(c => c.key === 'TEXT_AND_MEDIA_ALIGNMENT');
  const sizeConfig = configs.find(c => c.key === 'TEXT_AND_MEDIA_SIZE');
  const alignment = alignConfig?.value?.[0];
  const size = sizeConfig?.value?.[0] ? Number(sizeConfig.value[0]) : undefined;

  return {
    ...(url ? { url } : {}),
    ...(mimeType ? { mimeType } : {}),
    ...(title ? { title } : {}),
    ...(alignment ? { alignment } : {}),
    ...(size !== undefined ? { size } : {}),
  };
}
